import type { QueriesObject, QueryResults, System, Time } from '../../odie';

import { BlockComponent } from '../components/BlockComponent';
import { BubblesBlockComponent } from '../components/BubblesBlockComponent';
import { BubblesBlockEntity } from '../entities/BlockEntity';
import type { GameScene } from '../GameScene';

/*
    handles bubbles block specifics
*/
export class BubblesBlockSystem implements System {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockBubbles';
  public static Queries: QueriesObject = {
    block: {
      components: [BlockComponent, BubblesBlockComponent],
    },
  };

  // fields
  //-------------------------------------------------------------------------
  // injected
  public scene!: GameScene;
  public queries!: QueryResults;

  // impl
  //-------------------------------------------------------------------------
  public update(time: Time) {
    this.queries.block.forEach((entity: BubblesBlockEntity) => {
      const view = entity.c.blockBubbles.view;
      if (!view.isAnimatingOut) {
        view.bubbles.forEach((bubble) => {
          bubble.tick += time.deltaTime * 0.001;
        });
        view.refreshBubbles();
      }
    });
  }
}
